import { IconButton } from "@mui/material";
import Close from "@mui/icons-material/Close";

const CloseButton = ({ onClick, size = 'default' }) => {
    return (<IconButton sx={{
        background: '#EAEAEA',
        maxWidth: 'max-content',
        padding: '4.5px',
        '&:hover': {
            background: '#E6E6E6',
            '& .MuiSvgIcon-root': {
                color: '#930500'
            }
        },
        width: size === 'small' ? '16px' : '24px',
        height: size === 'small' ? '16px' : '24px',
    }} onClick={onClick}>
        <Close color={'#494949'} sx={{ height: size === 'small' ? '10px' : '16px', width: size === 'small' ? '10px' : '16px' }} />
    </IconButton>)
}


export default CloseButton;
